export default __webpack_public_path__ + "5d6d5a3f395b9dbf57745a39c671a5c3.png";